import apiFinancial from "../config/api_financial";
import getHeaders from "./getHeaders";

// const apiFinancial = axios.create({
//   baseURL: "http://localhost:8086",
// });

export function indexAllBankStatementFarm(payload) {
  const { groupId, farmId, signal } = payload;

  return apiFinancial.get(
    `/bovexo/${groupId}/farms/${farmId}/bank/statements`,
    getHeaders(false, signal)
  );
}

export function pageAllBankStatementTransactionsFarm(payload) {
  const { groupId, farmId, search, page, size, sort, signal } = payload;

  const orderS =
    Object.entries(sort).length > 0 && sort.order
      ? sort.order === "descend"
        ? "DESC"
        : sort.order === "ascend"
        ? "ASC"
        : "DESC"
      : "DESC";
  const requestParams = `page=${page > 0 ? page - 1 : 0}&size=${size ?? 10}${
    sort && Object.entries(sort).length > 0 && sort.order
      ? `&sort=${sort.field}&direction=${orderS}`
      : ""
  }${search && search !== "" ? `&search=${search}` : ""}`;

  return apiFinancial.get(
    `/bovexo/${groupId}/farms/${farmId}/bank/statements/transactions?${requestParams}`,
    getHeaders(false, signal)
  );
}

export function uploadBankStatementFarm(payload) {
  const { groupId, farmId, body, signal } = payload;

  return apiFinancial.post(
    `/bovexo/${groupId}/farms/${farmId}/bank/statements/extract/ofx`,
    body,
    getHeaders(true, signal)
  );
}

export function storeBankStatementFarm(payload) {
  const { groupId, farmId, body, signal } = payload;

  return apiFinancial.post(
    `/bovexo/${groupId}/farms/${farmId}/bank/statements`,
    body,
    getHeaders(false, signal)
  );
}
